import { create } from "zustand";

import { DataHandleLoginClass } from "@/components/authentication/utils/LoginCommoneInterfaceProps";
import { LoginStepEnums } from "@/types/product/account/authentication";

interface AuthenticationStoreInterface {
  openLoginPopup: boolean;
  isOpenedFromRegisterCard: boolean;
  openLogoutPopup: boolean;
  openSocialListPopup: boolean;
  pathRedirectClosePopup: string; // NOTE - set path ตอนกด close popup login
  isRedirectBackClosePopup: boolean; // NOTE - จะ redirect ก่อน path หน้า
  loginStep: LoginStepEnums;
  loginData: DataHandleLoginClass;
  title?: string; // NOTE - title ของ popup login
  setOpenLoginPopup: (trigger: boolean, fromRegisterCard?: boolean) => void;
  setOpenLogoutPopup: (trigger: boolean) => void;
  setOpenSocialListPopup: (trigger: boolean) => void;
  setPathRedirectClosePopup: (trigger: string) => void;
  setIsRedirectBackClosePopup: (trigger: boolean) => void;
  setLoginStep: (trigger: LoginStepEnums) => void;
  setLoginData: (trigger: DataHandleLoginClass) => void;
  setTitle: (title: string) => void;
}

export const useAuthenticationStore = create<AuthenticationStoreInterface>(
  (set) => ({
    openLoginPopup: false,
    isOpenedFromRegisterCard: false,
    openLogoutPopup: false,
    openSocialListPopup: false,
    pathRedirectClosePopup: "",
    isRedirectBackClosePopup: false,
    loginStep: LoginStepEnums.PHONE,
    loginData: new DataHandleLoginClass({}),
    title: undefined,
    setOpenLoginPopup: (trigger, fromRegisterCard = false) =>
      set({
        openLoginPopup: trigger,
        isOpenedFromRegisterCard: fromRegisterCard,
      }),
    setOpenLogoutPopup: (trigger) => set({ openLogoutPopup: trigger }),
    setOpenSocialListPopup: (trigger) => set({ openSocialListPopup: trigger }),
    setPathRedirectClosePopup: (trigger) =>
      set({ pathRedirectClosePopup: trigger }),
    setIsRedirectBackClosePopup: (trigger) =>
      set({ isRedirectBackClosePopup: trigger }),
    setLoginStep: (trigger) => set({ loginStep: trigger }),
    setLoginData: (trigger) => set({ loginData: trigger }),
    setTitle: (title) => set({ title }),
  }),
);
